document.addEventListener('click', event => {
  const button=event.target.closest('[data-nll-back]');
  if (!button) return;
  const previous=document.referrer;
  try {
    if (previous && new URL(previous).origin===location.origin && history.length>1) {
      history.back();
      return;
    }
  } catch (_) {}
  location.assign(window.Shopify?.routes?.root || '/');
});